import { createSlice } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from '@Store/store'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface LayoutState {}

const initialState: LayoutState = {}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {},
})

const { actions, reducer } = layoutSlice

const useLayoutState = (): LayoutState => useSelector((state) => state.layout)

const useLayoutActions = () => {
  const dispatch = useDispatch()

  return {}
}

export default reducer
export { useLayoutState, useLayoutActions }
